import { apiPost, apiGet } from '../../api/index';
import { urlUsers } from '../../api/urls';

export const FETCH_USERS_LOADING = 'FETCH_USERS_LOADING';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILED = 'FETCH_USERS_FAILED';

export const fetchUsersLoading = () => ({ type: FETCH_USERS_LOADING });
export const fetchUsersSuccess = users => ({ type: FETCH_USERS_SUCCESS, payload: users });
export const fetchUsersFailed = error => ({ type: FETCH_USERS_FAILED, payload: error });

export function fetchUsers(params) {
  const pageInfo = params && params.pageInfo
    ? params.pageInfo
    : { page: 1, pageSize: 15 };
  return apiPost(`${urlUsers}/all`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function fetchAllUsers(params) {
  return apiGet(`${urlUsers}/all`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function fetchAllUAuditLog(params) {
  const pageInfo = params && params.pageInfo
    ? params.pageInfo
    : { page: 1, pageSize: 15 };
  return apiPost(`${urlUsers}/all_auditlog`, pageInfo)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}

export function fetchFormDatas(params) {
  return apiGet(`${urlUsers}/form_data`)
    .then((res) => {
      if (res.error) {
        throw (res.error);
      }
      if (params && params.onSuccess) params.onSuccess(res);
      return res;
    })
    .catch((error) => {
      if (params && params.onError) params.onError(error);
    });
}
